import { SELECT_CATEGORY } from './types';

export const select = id => ({
	type: SELECT_CATEGORY,
	selected: id,
});
